<template>
  <el-dialog
    v-loading="isLoading"
    title="Create New Enquiry"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="form"
      :model="ticket"
      label-width="120px"
    >
      <el-form-item label="Name">
        <el-input v-model="ticket.name" />
      </el-form-item>
      <el-form-item label="Email">
        <el-input v-model="ticket.email" />
      </el-form-item>
      <el-form-item label="Phone">
        <el-input v-model="ticket.phone" />
      </el-form-item>
      <el-form-item label="Type">
        <el-select
          v-model="ticket.type"
          placeholder="Select a type"
        >
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Priority">
        <el-select
          v-model="ticket.priority"
          placeholder="Select a priority"
        >
          <el-option
            label="Low"
            :value="1"
          />
          <el-option
            label="Medium"
            :value="2"
          />
          <el-option
            label="High"
            :value="3"
          />
          <el-option
            label="Urgent"
            :value="4"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Live Chat">
        <el-switch
          v-model="ticket.show_in_openfreight"
          active-text="On"
          inactive-text="Off"
        />
      </el-form-item>
      <el-form-item label="Description">
        <el-input
          v-model="ticket.description"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        @click.native="createTicket"
      >
        Create
      </el-button>
    </template>
  </el-dialog>
</template>
<script>
import Request, { POST } from '@/plugins/sdk/Request'

export default {
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isVisible: true,
      formLabelWidth: '120px',
      ticket: {},
      isLoading: false,
      types: [
        {
          name: 'Additional Delivery Instructions',
          value: 'Additional Delivery Instructions'
        },
        {
          name: 'ATL Request',
          value: 'ATL Request'
        },
        {
          name: 'Cancel Consignment',
          value: 'Cancel Consignment'
        },
        {
          name: 'Check Address',
          value: 'Check Address'
        },
        {
          name: 'Contact Details Required',
          value: 'Contact Details Required'
        },
        {
          name: 'Damaged Freight',
          value: 'Damaged Freight'
        },
        {
          name: 'Depot Collection',
          value: 'Depot Collection'
        },
        {
          name: 'ETA Request',
          value: 'ETA Request'
        },
        {
          name: 'Lost in Transit',
          value: 'Lost in Transit'
        },
        {
          name: 'Missed Pickup',
          value: 'Missed Pickup'
        },
        {
          name: 'Missing Paperwork',
          value: 'Missing Paperwork'
        },
        {
          name: 'Monitor',
          value: 'Monitor'
        },
        {
          name: 'Partial Lost in Transit',
          value: 'Partial Lost in Transit'
        },
        {
          name: 'POD Request',
          value: 'POD Request'
        },
        {
          name: 'Pre-alert',
          value: 'Pre-alert'
        },
        {
          name: 'Redelivery Request',
          value: 'Redelivery Request'
        },
        {
          name: 'Report',
          value: 'Report'
        },
        {
          name: 'Return to Sender',
          value: 'Return to Sender'
        },
        {
          name: 'Short Delivery',
          value: 'Short Delivery'
        },
        {
          name: 'WOP Letter',
          value: 'WOP Letter'
        }
      ]
    }
  },
  methods: {
    async createTicket () {
      this.isLoading = true

      this.ticket.consignment = this.consignment.id

      const request = await (Object.assign(new Request(), {
        method: POST,
        _pathname: 'freshdesk/ticket/biller',
        body: this.ticket
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        this.$message.success('Ticket Created')
      } else {
        this.$message.error('Unable to create ticket')
      }

      this.isLoading = false
      this.isVisible = false
    }
  }
}
</script>
